<template>
	<div class="grid-cell-content grid-cell-sizer">
		<span @click="row_headerCheckboxClicked" class="flex-grow-1 d-flex justify-content-center">
			<icon :icon="icon" />
		</span>
		<div class="dropleft">
			<button class="btn menu-btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<icon name="caret-down fas" style="font-size: 10px" />
			</button>
			<ul class="dropdown-menu multi-level py-0" role="menu" aria-labelledby="dropdownMenu">
				<!-- Select All -->
				<li class="dropdown-item py-2 pr-2 pl-5" @click="value_addAll">
					<a>
						<icon name="check-square" />
						<span class="mr-3">{{ $t("table.select.select-all") }}</span>
					</a>
				</li>
				<!-- Select None -->
				<li class="dropdown-item py-2 pr-2 pl-5" @click="value_removeAll">
					<a>
						<icon name="square far" />
						<span class="mr-3">{{ $t("table.select.select-none") }}</span>
					</a>
				</li>
				<!-- Select reverse -->
				<li class="dropdown-item py-2 pr-2 pl-5" @click="value_reverse">
					<a>
						<icon name="exchange" />
						<span class="mr-3">{{ $t("table.select.select-reverse") }}</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Icon from '../general/icon.vue'

	export default {
		name: 'gridSelectMenu',

		// Props
		props: {
			icon: {
				type: String,
			},
		},

		emits: ['row_headerCheckboxClicked', 'value_addAll', 'value_removeAll', 'value_reverse'],

		// Components
		components: {
			Icon
		},

		// Methods
		methods: {
			row_headerCheckboxClicked(e) {
				this.$emit('row_headerCheckboxClicked', e)
			},
			value_addAll() {
				this.$emit('value_addAll')
			},
			value_removeAll() {
				this.$emit('value_removeAll')
			},
			value_reverse() {
				this.$emit('value_reverse')
			}
		},
	}
</script>

<style></style>